import { Component, OnInit } from "@angular/core";
import { Feature, ProductDetails } from "@brain/data";
import { takeUntil } from "rxjs/operators";
import { AssetDetailSectionDirective } from "../asset-section";

@Component({
    selector: "brain-asset-detail-features",
    templateUrl: "./features.component.html",
    styleUrls: ["./features.component.scss"]
})
export class AssetDetailFeaturesComponent extends AssetDetailSectionDirective implements OnInit {

  public key = "Features";

  public featuresArray: Feature[];

  public ngOnInit(): void {

      this.assetDetail.productDetail$
          .pipe(takeUntil(this.destroy$))
          .subscribe((pd: ProductDetails) => this.featuresArray = pd.detail.capabilities ?? []);

      super.ngOnInit();
  }
}
